export enum SideNavigationStatusColor {
  Blue = 'blue',
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Grey = 'grey',
  LightGray = 'light-grey'
}
